import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", href: "/" },
  { label: "体育竞技", href: "/category/sports" },
  { label: "真人娱乐", href: "/category/live" },
  { label: "电子游艺", href: "/category/slots" },
  { label: "优惠资讯", href: "/articles" },
  { label: "关于我们", href: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span
              className={`text-xl font-heading font-bold tracking-wide ${
                scrolled || !isHome ? "text-primary-500" : "text-background-50"
              }`}
            >
              必赢亚洲
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href ||
                (item.href !== "/" && location.pathname.startsWith(item.href));
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "text-primary-500 bg-primary-500/10"
                      : scrolled || !isHome
                        ? "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                        : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className="px-5 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即注册
            </a>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled || !isHome ? "text-foreground-700" : "text-background-50"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-3 px-4">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href ||
                (item.href !== "/" && location.pathname.startsWith(item.href));
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`block px-3 py-2.5 text-sm rounded-md transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-500 bg-primary-500/10 font-medium"
                      : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <a
              href="#"
              className="block mt-2 px-5 py-2.5 text-sm font-medium text-center text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-all duration-200 cursor-pointer"
            >
              立即注册
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}